import { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

type Variant = 'primary' | 'secondary';

type BaseProps = {
  children: ReactNode;
  variant?: Variant;
  className?: string;
};

type LinkProps = BaseProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'className' | 'children'> & {
    href: string;
  };

type ButtonProps = BaseProps &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children'>;

const baseClass =
  'inline-flex items-center justify-center rounded-lg border px-4 py-2 font-mono text-[0.65rem] uppercase tracking-[0.2em] transition duration-200 hover:-translate-y-0.5 hover:shadow-[0_0_18px_rgba(183,255,106,0.2)] active:translate-y-0';

const variantClasses: Record<Variant, string> = {
  primary:
    'border-brand-lime/70 bg-[linear-gradient(180deg,rgba(183,255,106,0.22),rgba(183,255,106,0.06))] text-brand-text hover:border-brand-lime hover:bg-brand-lime/20',
  secondary:
    'border-brand-aqua/55 bg-[linear-gradient(180deg,rgba(88,247,182,0.15),rgba(88,247,182,0.03))] text-brand-text hover:border-brand-aqua hover:bg-brand-aqua/14'
};

export const SystemButton = (props: LinkProps | ButtonProps) => {
  if ('href' in props) {
    const { children, variant = 'primary', className, href, ...rest } = props;
    return (
      <a href={href} {...rest} className={cn(baseClass, variantClasses[variant], className)}>
        {children}
      </a>
    );
  }

  const { children, variant = 'primary', className, ...rest } = props;
  return (
    <button {...rest} className={cn(baseClass, variantClasses[variant], className)}>
      {children}
    </button>
  );
};
